module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10256.9e8c15bb.jpg";